import React from 'react'
import Spinner from 'components/Spinner'
import styled from 'styled-components'

const LoadingStateContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  flex-grow: 1;
  margin: 16px 0;
  align-self: center;
`

const StyledSpinner = styled(Spinner)`
  display: flex;
  align-self: center;
`

const LoadingState = () => (
  <LoadingStateContainer>
    <StyledSpinner size="40px" primary />
  </LoadingStateContainer>
)

export default LoadingState
